export default __webpack_public_path__ + "static/media/imageFlip.cee9c624.webp";